import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import React from "react";

export default function MergeDeliveryOrderDialog(props) {
  const { onCancel, open, onSubmit, submitButtonColor = "primary" } = props;
  const [deliveryOrderId, setDeliveryOrderId] = React.useState("");
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>組合運送單</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box
            component="form"
            noValidate
            sx={{
              display: "grid",
            }}
          >
            <FormControl fullWidth>
              <TextField
                id="stockonhand_refill_id"
                name="stockonhand_refill_id"
                label="組合單縞唬"
                placeholder="輸入組合單縞唬"
                vlaue={deliveryOrderId}
                onChange={(event) => setDeliveryOrderId(event.target.value)}
              ></TextField>
            </FormControl>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>取消</Button>
        <Button
          onClick={() => onSubmit(deliveryOrderId)}
          color={submitButtonColor}
          type="submit"
        >
          提交
        </Button>
      </DialogActions>
    </Dialog>
  );
}
